import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const fetchContactRequests = async () => {
  const response = await axiosInstance.get("admin/contact-request", {
    headers,
  });
  return response.data;
};

export const deleteContactRequest = async (id) => {
  return await axiosInstance.delete(`admin/contact-request/${id}`, { headers });
};
